import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/marketing/Navbar";
import Footer from "@/components/marketing/Footer";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  useEffect(() => {
    const tag = document.createElement("meta");
    tag.name = "robots";
    tag.content = "noindex";
    document.head.appendChild(tag);
    const prev = document.title;
    document.title = "Page not found | NetLift";
    return () => { document.head.removeChild(tag); document.title = prev; };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="mx-auto flex max-w-3xl flex-col items-start px-5 py-24 sm:px-8" data-testid="not-found-page">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-editorial">404</p>
        <h1 className="mt-3 font-heading text-4xl font-semibold tracking-tight text-ink sm:text-5xl">Page not found.</h1>
        <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-600">
          The page you are looking for does not exist or may have moved.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Button asChild className="bg-editorial hover:bg-editorial/90" data-testid="notfound-home-cta">
            <Link to="/">Go to homepage <ArrowRight className="ml-2 h-4 w-4" /></Link>
          </Button>
          <Button asChild variant="outline" className="border-ink/20">
            <Link to="/resources">Browse resources</Link>
          </Button>
        </div>
      </section>
      <Footer />
    </div>
  );
}
